







import { Component, Vue } from 'vue-property-decorator';
import { FitLoading, FitDialog } from '@/fit-components';
import { reportIndexPvUvAndTimeCost } from "@tencent/ppd-base-libs";


@Component({
  components: {
    FitLoading,
    FitDialog,
  },
})
export default class App extends Vue {
  created() {
    reportIndexPvUvAndTimeCost();
    return;
  }
}
